import logo from './logo.svg';
import './App.css';
import { HomeWrapper } from "./components/screens/home/HomeWrapper";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {Company} from "./components/screens/company/Company";
import {Mission} from "./components/screens/mission/Mission";
import {Services} from "./components/screens/services/Services";
import {ContactUs} from "./components/screens/contact/ContactUs";

function App() {
  return (
     <BrowserRouter>
      <Routes>
          <Route path="/" element={<HomeWrapper />} />
          <Route path="/company" element={<Company />} />
          <Route path="/mission" element={<Mission />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact-us" element={<ContactUs />} />
      </Routes>
</BrowserRouter>

  );
}

export default App;
